// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--uURftqrVmb","block":"block--Qo4h2fK26C","item":"item--VH6iG24bpq","image":"image--H3LoK_rqPT"};